import { render, staticRenderFns } from "./org-update.vue?vue&type=template&id=7003b90c"
import script from "./org-update.vue?vue&type=script&lang=js"
export * from "./org-update.vue?vue&type=script&lang=js"
import style0 from "./org-update.vue?vue&type=style&index=0&id=7003b90c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports